<template>
    <v-dialog v-model="show" persistent max-width="700px" max-height="800px">
        <!-- <div id="app"> -->
        <!-- <v-app id="inspire"> -->
        <v-card class="d-flex flex-column" style="max-height: 600px; overflow: hidden;">
            <v-card-title>
                <span class="text-h5">Nueva Obra N°: {{ numobra }}
                    <p> Cliente N° {{ numcliente }} - {{ nomcliente }}
                    </p>
                    <p> N° SGI IN-{{ numsgi }}
                    </p>
                </span>
            </v-card-title>
            <v-card-text style="overflow: auto;">
                <v-container>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field dense label="Nombre de la Obra" v-model="nomobra"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field dense v-model="fecha" label="Fecha"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-select dense v-model="responsable" label="Responsable" :items="listadoresp"
                                item-text="nombre" item-value="nombre"></v-select>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-select dense v-model="fabelec" label="Responsable Fab. Elec." :items="listadoresp"
                                item-text="nombre" item-value="nombre" class="pa-0 ma-0"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-select dense v-model="fabmec" label="Responsable Fab. Mec." :items="listadoresp"
                                item-text="nombre" item-value="nombre" class="pa-0 ma-0"></v-select>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field dense v-model="numicssa" label="N° ICSSA" persistent-hint
                                hint="Código definido por Administración"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="show = false">
                    Cerrar
                </v-btn>
                <v-btn color="blue darken-1" text @click="guardarobra()">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
        <!-- </v-app> -->
        <!-- </div> -->
    </v-dialog>
</template>
<script>
import { toPlainObject } from "lodash";
import axios from "../../../axios-auth";
import moment from "moment";
export default {
    data: (vm) => ({
        numobra: "",
        nomobra: "",
        numsgi: "",
        responsable: "",
        fabelec: "",
        fabmec: "",
        fecha: moment().format("DD/MM/YYYY"),
        numicssa: "",
        listadoresp: [],

    }),
    props: ["visible", "numcliente", "nomcliente"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarnumobra();
                    this.cargarnumsgi();
                    this.cargarresponsable();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    //this.$refs.form.resetValidation();
                    //this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargarnumobra() {
            let self = this;
            let numcliente = this.numcliente;
            axios
                .get("/Ingenieria/CodigoObra", {
                    params: {
                        numcliente: numcliente
                    }
                })
                .then((response) => {
                    self.numobra = response.data;
                })
                .catch((error) => {
                    self.numobra = "";
                });
        },

        cargarnumsgi() {
            let self = this;
            axios
                .get("/Ingenieria/CodigoSGI", {
                })
                .then((response) => {
                    self.numsgi = response.data;
                })
                .catch((error) => {
                    self.numsgi = "";
                });
        },
        cargarresponsable() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoproyectistas", {
                })
                .then((response) => {
                    self.listadoresp = response.data;
                })
                .catch((error) => {
                    self.listadoresp = [];
                });
        },

        guardarobra() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Obra",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        numcliente: this.numcliente,
                        nomobra: this.nomobra,
                        numobra: this.numobra,
                        numsgi: this.numsgi,
                        numicssa: this.numicssa,
                        responsable: this.responsable,
                        fabelec: this.fabelec,
                        fabmec: this.fabmec,
                        fecha: this.fecha,
                        estado: "P",

                    };

                    let self = this;
                    axios
                        .post("/Ingenieria/GuardarObra", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Obra guardada con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            setTimeout(() => {
                                self.$router.push({ name: "IngListadoCliente" });
                            }, 2000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        vaciarListado() {
            const initialState = this.$options.data.call(this);

            Object.keys(initialState).forEach((key) => {
                this[key] = initialState[key];
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 1500,
            });
        },
    },
};
</script>